import type { FC } from 'react';

import './LeadsFunnelLeadCardSkeleton.scss';

export const LeadsFunnelLeadCardSkeleton: FC = () => (
  <div className="LeadsFunnelLeadCardSkeleton" aria-hidden="true">
    <div className="LeadsFunnelLeadCardSkeleton__header">
      <span className="LeadsFunnelLeadCardSkeleton__avatar" />
      <div className="LeadsFunnelLeadCardSkeleton__identity">
        <span className="LeadsFunnelLeadCardSkeleton__line LeadsFunnelLeadCardSkeleton__line--name" />
        <span className="LeadsFunnelLeadCardSkeleton__line LeadsFunnelLeadCardSkeleton__line--phone" />
      </div>
    </div>

    <span className="LeadsFunnelLeadCardSkeleton__line LeadsFunnelLeadCardSkeleton__line--message" />

    <div className="LeadsFunnelLeadCardSkeleton__tags">
      <span className="LeadsFunnelLeadCardSkeleton__tag" />
      <span className="LeadsFunnelLeadCardSkeleton__tag" />
    </div>
  </div>
);
